import{a as r}from"./chunk-2HA4XQFN.js";var d=r(t=>t%2===1,"isOdd");export{d as a};
